import React, { Component } from "react";
import { ProductTile } from "components/product-collection/product-collection-views/product-collection-tile-view/product-tile";
import ContentLoader from "react-content-loader";

import ViewBase from "./base";

const ITEM_HEIGHT = 380;
const ITEM_WIDTH = 240;

const NuORDERLoadingShimmer = () => (
    <ContentLoader height={380} width={240} speed={3} primaryColor="#f3f3f3" secondaryColor="#ecebeb">
        <rect x="9" y="15" rx="5" ry="5" width="220" height="264" />
        <rect x="11" y="295" rx="0" ry="0" width="219" height="19" />
        <rect x="149" y="304" rx="0" ry="0" width="0" height="0" />
        <rect x="149" y="304" rx="0" ry="0" width="0" height="0" />
        <rect x="11" y="322" rx="0" ry="0" width="220" height="13" />
        <rect x="156" y="333" rx="0" ry="0" width="0" height="0" />
        <rect x="10" y="343" rx="0" ry="0" width="220" height="13" />
    </ContentLoader>
);

class AssortmentCard extends Component {
    static height = ITEM_HEIGHT;
    static width = ITEM_WIDTH;
    static horizontalOffset = 8;
    static verticalOffset = 12;

    handleAddItem = (e) => {
        e.stopPropagation();
        const { item } = this.props;
        this.props.actions.onActiveListAdd(item);
    };

    handleRemoveItem = (e) => {
        e.stopPropagation();
        // intentionally blank for now, since we don't know
        // which rows to remove if the product appears multiple times
    };

    handleItemClick = () => {
        const { actions, item } = this.props;
        actions.onItemClick(item);
    };

    render() {
        const { item, bulkItems, scope } = this.props;
        if (!item) {
            return <NuORDERLoadingShimmer />;
        }

        const itemInAssortment = bulkItems.find((assortmentItem) => {
            return assortmentItem.getIn(["fields", "_product_id", "string_value"]) === item._id;
        });

        const primaryImageUrl =
            item.getImageUrl(scope, "T", 0) || "//cdn1.nuorder.com/brands/1womenswholesale_missing.jpg";

        return (
            <ProductTile
                isSortable={false}
                id={item._id}
                productId={item._id}
                imageUrl={primaryImageUrl}
                primaryAttribute={item.name}
                secondaryAttribute={item.formattedMSRPRange("USD", scope)}
                tertiaryAttributes={[item.style_number, item.color]}
                // additionalColors?: string[]; // #hex; https://url; name
                onSelectItem={itemInAssortment ? this.handleRemoveItem : this.handleAddItem}
                selected={itemInAssortment}
                showLinking={false}
                onLinkItem={() => {}}
                index={2}
                onItemClick={this.handleItemClick}
            />
        );
    }
}

export default ViewBase(AssortmentCard);
